/*	Copyright (c) 1996 - 2026 NoWatt Ltd				*/
/*	  All Rights Reserved  											*/

import React from 'react';
import { createRoot } from 'react-dom/client';
import HomePage from './components/HomePage';
import MmPage from './components/MmPage';
import AnalysisPage from './components/AnalysisPage';
import InsidePage from './components/InsidePage';
import SmpPage from './components/SmpPage';
import LoginPage from './components/LoginPage';
import UsagePage from './components/UsagePage';
import TermsPage from './components/TermsPage';

type PageKey = 'home' | 'mm' | 'analysis' | 'inside' | 'smp' | 'login' | 'usage' | 'terms';
type PageComponentProps = { user: string; message?: string };

const TITLES: Record<PageKey, string> = {
  home: 'ΠΟωaττ',
  mm: 'ΠΟωaττ - Monitored Maintenance',
  analysis: 'ΠΟωaττ - Data Analysis',
  inside: 'ΠΟωaττ - inside',
  smp: 'ΠΟωaττ - Smart Monitoring PLUS',
  login: 'ΠΟωaττ - Sign-in',
  usage: 'ΠΟωaττ - Usage',
  terms: 'ΠΟωaττ - Terms & Conditions',
};

const PAGES: Record<PageKey, (props: PageComponentProps) => React.JSX.Element> = {
  home: ({ user }) => <HomePage user={user} />,
  mm: ({ user }) => <MmPage user={user} />,
  analysis: ({ user }) => <AnalysisPage user={user} />,
  inside: ({ user }) => <InsidePage user={user} />,
  smp: ({ user }) => <SmpPage user={user} />,
  login: ({ user, message }) => <LoginPage user={user} message={message} />,
  usage: ({ user }) => <UsagePage user={user} />,
  terms: ({ user }) => <TermsPage user={user} />,
};

const rootEl = document.getElementById('app');
if (!rootEl) throw new Error('Missing #app root');

const page = (rootEl.dataset.page as PageKey | undefined) ?? 'home';
const user = rootEl.dataset.user ?? '0';
const message = rootEl.dataset.message;
const renderPage = PAGES[page] ?? PAGES.home;

document.title = TITLES[page] ?? TITLES.home;

createRoot(rootEl).render(renderPage({ user, message }));
